/* Per-variant media suites.
   Media tagged '#v:<len>-<thickness>' in alt renders with data-vgroups;
   this filters the gallery + thumbnails to the selected variant's suite.
   Server-side Liquid handles first paint.

   Two triggers:
   1. Dawn's PUB_SUB variantChange (native picker products).
   2. Direct clicks on the custom pill picker (.variant-btn) — the custom
      picker bypasses Dawn's variant pipeline entirely, so we read the
      selected combo straight from the picker DOM. */
(function () {
  function comboFromText(s) {
    s = (s || '').toLowerCase();
    var len = s.indexOf('12"') > -1 ? '12' : s.indexOf('6"') > -1 ? '6' : null;
    var th =
      s.indexOf('jumbo') > -1 ? 'jumbo' : s.indexOf('midsize') > -1 ? 'midsize' : s.indexOf('thick') > -1 ? 'thick' : null;
    return len && th ? len + '-' + th : null;
  }

  function selectedComboFromPicker() {
    var selected = document.querySelectorAll('.variant-picker .variant-btn.selected');
    if (!selected.length) return null;
    var text = [];
    selected.forEach(function (b) { text.push(b.getAttribute('data-value') || b.textContent); });
    return comboFromText(text.join(' '));
  }

  function applyFilter(combo) {
    if (!combo) return;
    var changed = false;
    document.querySelectorAll('[data-vgroups]').forEach(function (el) {
      var show = el.getAttribute('data-vgroups').split(' ').indexOf(combo) > -1;
      if (el.classList.contains('media-vhidden') === show) changed = true;
      el.classList.toggle('media-vhidden', !show);
    });
    if (!changed) return;

    // if the active slide is now hidden, activate the first visible one
    var active = document.querySelector('.product__media-list > li.is-active');
    if (!active || active.classList.contains('media-vhidden')) {
      var first = document.querySelector('.product__media-list > li:not(.media-vhidden)');
      var gallery = document.querySelector('media-gallery');
      if (first && gallery && gallery.setActiveMedia) {
        gallery.setActiveMedia(first.getAttribute('data-media-id'), true);
      }
    }
    syncCounter();
    // let Dawn's sliders recalculate pages/arrows
    window.dispatchEvent(new Event('resize'));
  }

  function syncCounter() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;
    var visible = gallery.querySelectorAll('.product__media-list > li:not(.media-vhidden)').length;
    gallery.querySelectorAll('.slider-counter--total').forEach(function (el) {
      el.textContent = visible;
    });
  }

  function init() {
    syncCounter();
    // trigger 1: Dawn pubsub (native picker flows)
    if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var v = event && event.data && event.data.variant;
        if (v && v.options) applyFilter(comboFromText(v.options.join(' ')));
      });
    }
    // trigger 2: custom pill picker clicks
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.variant-picker .variant-btn')) return;
      window.setTimeout(function () {
        applyFilter(selectedComboFromPicker());
      }, 60);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Gallery overlay arrows (desktop): endless cycle through visible media.
   Uses the same media-vhidden filter as the suite logic above, so arrows
   only walk the current variant's image set. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.bwl-gal-nav');
    if (!btn) return;
    var gallery = btn.closest('media-gallery');
    if (!gallery || !gallery.setActiveMedia) return;
    var lis = Array.prototype.slice.call(
      gallery.querySelectorAll('.product__media-list > li:not(.media-vhidden)')
    );
    if (lis.length < 2) return;
    var active = gallery.querySelector('.product__media-list > li.is-active');
    var idx = lis.indexOf(active);
    if (idx < 0) idx = 0;
    var dir = btn.classList.contains('bwl-gal-nav--next') ? 1 : -1;
    var target = lis[(idx + dir + lis.length) % lis.length];
    gallery.setActiveMedia(target.getAttribute('data-media-id'), false);
  });
})();

/* Arrow discoverability: arrows start visible; after the pointer has been
   over the gallery and leaves it once, is-nav-quiet switches them to
   hover-reveal (desktop CSS handles the rest). */
(function () {
  function arm() {
    document.querySelectorAll('.bwl-gal-nav--next').forEach(function (btn) {
      var comp = btn.closest('slider-component');
      if (!comp || comp.dataset.navQuietArmed) return;
      comp.dataset.navQuietArmed = '1';
      comp.addEventListener('mouseleave', function onLeave() {
        comp.classList.add('is-nav-quiet');
        comp.removeEventListener('mouseleave', onLeave);
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arm);
  } else {
    arm();
  }
})();

/* Phone swipe hint: fades out after the first swipe of the gallery. */
(function () {
  function arm() {
    document.querySelectorAll('.bwl-swipe-hint').forEach(function (hint) {
      var comp = hint.closest('slider-component');
      var scroller = comp && comp.querySelector('.product__media-list');
      if (!scroller || hint.dataset.armed) return;
      hint.dataset.armed = '1';
      var dismiss = function () {
        hint.classList.add('is-dismissed');
        setTimeout(function () { hint.remove(); }, 450);
        scroller.removeEventListener('scroll', dismiss);
        scroller.removeEventListener('touchmove', dismiss);
      };
      scroller.addEventListener('scroll', dismiss, { passive: true, once: true });
      scroller.addEventListener('touchmove', dismiss, { passive: true, once: true });
    });
  }
  function armLater() { setTimeout(arm, 800); }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', armLater);
  } else {
    armLater();
  }
})();
